import { RouteRecordRaw } from 'vue-router';

// 管理者用サイトをビルドする時のRouter
const routesManage: RouteRecordRaw[] = [
  {
    path: '/signin',
    component: () => import('pages/manage/SigninPage.vue'),
  },
  {
    path: '/',
    component: () => import('layouts/manage/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/manage/EditPage.vue') },
    ],
  },
  {
    path: '/regulars',
    component: () => import('layouts/manage/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/manage/RegularsPage.vue') },
    ],
  },
  {
    path: '/reservations',
    component: () => import('layouts/manage/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/manage/ReservationPage.vue'),
      },
    ],
  },
  {
    path: '/general',
    component: () => import('layouts/manage/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/manage/GeneralPage.vue'),
      },
    ],
  },
  {
    path: '/calling',
    component: () => import('layouts/manage/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/manage/CallingPage.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];
// iPad用のサイトをビルドする時のRouter
const routesIPad: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('pages/app/StartupPage.vue'),
  },
  {
    path: '/search/:transition',
    component: () => import('pages/app/SearchPage.vue'),
  },
  {
    path: '/recept',
    component: () => import('pages/app/ReceptPage.vue'),
  },
];

export default process.env.ROUTER_TYPE == 'ipad' ? routesIPad : routesManage;
